module.exports = __webpack_public_path__ + "img/zap-circle.70888877.svg";